export const HelpContentContainer = ({
    children,
}: {
    children: React.ReactNode;
}) => <div className="h-[500px] pt-4">{children}</div>;
